/**
 * @author xyguo
 * @date 2020-12-24
 * @description 班级远程认证环节弹出
 */
import React from "react";
import moment from "moment";

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
const columns = () => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: '环节名称',
      name: 'aideName',
      dataIndex: 'aideName',
      searchItem: {},
      tableItem: {
        width: 150
      }
    },
    {
      title: '环节开始时间',
      name: 'startTime',
      dataIndex: 'startTime',
      tableItem: {
        width: 200
      }
    },
    {
      title: '环节结束时间',
      name: 'endTime',
      dataIndex: 'endTime',
      tableItem: {
        width: 220
      }
    },
    {
      title: '班级名称',
      name: 'className',
      dataIndex: 'className',
      searchItem: {},
      tableItem: {
        width: 150
      }
    },
    {
      title: '认证场次',
      name: 'studentRemoteAuthDetailName',
      dataIndex: 'studentRemoteAuthDetailName',
      searchItem: {},
      tableItem: {
        width: 150
      }
    },
    {
      title: '认证名称',
      name: 'remoteAuthName',
      dataIndex: 'remoteAuthName',
      searchItem: {},
      tableItem: {
        width: 200
      }
    },
    
    
    
  ]
}
const tableApi = (api = {}) => {
  return {
    path: 'classManagement/getClassAideRemoteAuthInfo',
    ...api
  }

}
const classAideRemoteAuth = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowkey: 'id',
    rowName: 'aideName',
    columns: columns(self),
    cols: {
      xs: 12,
      md: 12,
      xl: 12
    },
    tableApi: tableApi(api)
  }
}

export default classAideRemoteAuth
